import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Monitor, Smartphone, FileText, Check, LogIn } from "lucide-react";
import DriverSample from "@/pages/preview/DriverSample";
import AdminSample from "@/pages/preview/AdminSample";
import InvoiceFonts from "@/pages/preview/InvoiceFonts";
import LoginSample from "@/pages/preview/LoginSample";
import { PALETTES, SITE_FONTS, FONTS_URL } from "@/pages/preview/palettes";

function PalettePicker({ cur, onPick }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="palette-picker">
      {PALETTES.map((p, i) => (
        <button key={p.id} data-testid={`palette-${p.id}`} onClick={() => onPick(i)}
          className={`flex items-center gap-2 px-3 py-2 rounded-xl border-2 bg-white text-sm font-bold ${cur === i ? "border-slate-900 shadow" : "border-slate-200"}`}>
          <span className="flex"><span className="w-5 h-5 rounded-full" style={{ background: p.primary }} /><span className="w-5 h-5 rounded-full -mr-1.5 border-2 border-white" style={{ background: p.accent }} /></span>
          التصميم {i + 1}: {p.name}{cur === i && <Check className="w-4 h-4" />}
        </button>
      ))}
    </div>
  );
}

function FontPicker({ cur, onPick }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="site-font-picker">
      {SITE_FONTS.map((f) => (
        <button key={f.id} data-testid={`site-font-${f.id.replace(/\s/g, "-")}`} onClick={() => onPick(f.id)} style={{ fontFamily: `'${f.id}', sans-serif` }}
          className={`px-3 py-2 rounded-xl border-2 bg-white ${cur === f.id ? "border-slate-900 shadow font-bold" : "border-slate-200"}`}>{f.name} — المحيط الأطلسي</button>
      ))}
    </div>
  );
}

export default function DesignSample() {
  const [view, setView] = useState("driver");
  const [pi, setPi] = useState(0);
  const [font, setFont] = useState("Tajawal");
  useEffect(() => {
    const l = document.createElement("link");
    l.rel = "stylesheet"; l.href = FONTS_URL;
    document.head.appendChild(l);
    return () => { l.remove(); };
  }, []);
  const p = PALETTES[pi];
  return (
    <div className="min-h-screen bg-slate-200 p-4 lg:p-8 space-y-4" data-testid="design-sample-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><h1 className="text-2xl font-black">عينات التصميم والخطوط</h1><p className="text-slate-600 text-sm">بيانات توضيحية فقط — النظام الحالي لم يتغير بعد</p></div>
        <Link to="/admin" data-testid="sample-back" className="btn btn-sm btn-ghost"><ArrowRight className="w-4 h-4" />العودة للنظام</Link>
      </div>
      <div className="flex flex-wrap gap-2">
        {[["login", "شاشة الدخول", LogIn], ["driver", "واجهة السائق", Smartphone], ["admin", "واجهة الإدارة", Monitor], ["invoice", "خطوط الفواتير", FileText]].map(([k, l, I]) => (
          <button key={k} data-testid={`sample-view-${k}`} onClick={() => setView(k)} className={`btn btn-sm ${view === k ? "btn-dark" : "btn-ghost"}`}><I className="w-4 h-4" />{l}</button>
        ))}
      </div>
      {view === "invoice" ? <InvoiceFonts /> : (
        <>
          <div className="space-y-2"><b className="text-sm">الألوان:</b><PalettePicker cur={pi} onPick={setPi} /></div>
          <div className="space-y-2"><b className="text-sm">خط الموقع:</b><FontPicker cur={font} onPick={setFont} /></div>
          <div key={p.id + view} className="fade-up">{view === "login" ? <LoginSample p={p} font={font} /> : view === "driver" ? <DriverSample p={p} font={font} /> : <AdminSample p={p} font={font} />}</div>
        </>
      )}
    </div>
  );
}
